export default {
  translation: {
    OpenApp: "Uygulamayı Aç",
    FAQ: "SSS",
    AboutUs: "Hakkımızda",
    Tutorials: "Öğreticiler",
    Blog: "Blog",
    MyPlansTitle: "Paketlerim",
    MyPlansDescription:
      "Bu bölümde tasarlayabileceğim paketlerin listesini görebilirsiniz. Bu paketlerin önceden hazırlanmadığını ve fiziksel durumunuz ile hedefinize göre tasarlandığını unutmayın. Rambody uygulamasını yükledikten sonra profilimden sohbet butonu ile benimle iletişime geçebilirsiniz.",
    ExpertiseTitle: "Uzmanlığım",
    AboutMeTitle: "Genel Bilgilerim",
    DownloadApps: "Uygulamayı İndir",
    DownloadApps_sharelink: "1. Uygulamayı indir",
    DownloadDescription: "",
    TutorialVideo: "Öğretici",
    TutorialVideoDescription:
      "Antrenman planlarının nasıl tasarlanacağına dair daha iyi kullanım ve bilgi için öğretici videoları burada izleyin.",
    CompanyDescription:
      "Rambody, antrenörler ve sporcular arasında özel antrenman ve beslenme planı sağlamak için bir iletişim platformudur.",
    AllRightsReserved: "Tüm hakları saklıdır 2019. Farosa Technologies Inc.",
    CompanyName: "Farosa Technologies Inc",
    Level: "Adım",
    HowToApplyProgram: "Paket için nasıl başvururum?",
    ApplyProgramLevel1: "Rambody uygulamasını indirin",
    ApplyProgramLevel2: "Uygulamada benim ID'mi ({0}) arayın",
    ApplyProgramLevel3: "İhtiyaçlarınız ve hedeflerinize göre birine başvurun",
    ApplyProgramLevel4:
      "Belirtilen süre içinde uygulamayı tasarlayın ve gönderin",
    Close: "Kapat",
    ReadMore: "Daha Fazla",
    Less: "Daha Az",
    experimental: "Deneysel",
    expert: "Uzman",
    amateur: "Amatör",
    totalSentPlans: "Toplam Gönderilen Planlar",
    download: "Rambody'yi İndir",
    requestPackage: "Plan Talep Et",
    info1: "2. Uygulamaya kayıt olun",
    info2: "3. Bu sayfaya geri dönün",
    info3: "4. Aşağıdaki butona tıklayın",
    redirectingToApp: "Rambody uygulamasını açmaya çalışıyor...",
    ifNotRedirected:
      "Uygulamanız yok mu? Kısa süre içinde indirme sayfasına yönlendireceğiz.",
  },
};
